import Text14 from '@sdk/components/ui/typography/Text14';
import Row from '@sdk/components/ui/spacing/Row';
import HorizontalSeparator from '@sdk/components/ui/HorizontalSeparator';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import { FeaturesGrid } from './featuresToLose.styles';
import { useFeaturesToLose } from './featuresToLose.hooks';

type Props = {
  isDowngradeOnly: boolean;
  subscriptionLevel: number;
  isOldPremium: boolean;
};

const FeaturesToLose = ({ isDowngradeOnly, subscriptionLevel, isOldPremium }: Props) => {
  const { features, primaryText, secondaryText } = useFeaturesToLose(
    isDowngradeOnly,
    subscriptionLevel,
    isOldPremium
  );

  return (
    <>
      <Row mBottom={20}>
        <Text14 themeColor={ThemeColorType.gray}>{primaryText}</Text14>
      </Row>
      <Row mBottom={10}>
        <Text14 semiBold themeColor={ThemeColorType.gray}>
          {secondaryText}
        </Text14>
      </Row>
      <HorizontalSeparator />
      <FeaturesGrid>
        {features.map((feature) => {
          return (
            <Row alignItems="center" key={feature.name}>
              {feature.icon}
              <Text14 themeColor={ThemeColorType.gray}>{feature.description}</Text14>
            </Row>
          );
        })}
      </FeaturesGrid>
    </>
  );
};

export default FeaturesToLose;
